// extracted by mini-css-extract-plugin
module.exports = {"container":"get-module--container--1GBjP","title":"get-module--title--1OD4J","btn":"get-module--btn--2G_FC","text":"get-module--text--3eilW"};